module.exports = __webpack_public_path__ + "static/media/lily-collins.1193ffeb.jpg";